import {Icon} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

interface CellAvailabilityAttrs {
    row: {
        offer_item_type?: 'tbo' | 'stock' | 'purchase'
        delivery_period?: number | null
        supplier_name?: string | null
        maximum_quantity?: number | null
        minimum_quantity?: number | null

        number_of_cases_in_stock: number
        number_of_cases_available: number
        number_of_cases_in_purchase: number
        number_of_cases_in_sales: number

        is_active?: boolean
    }
}

export class CellAvailability extends MithrilComponent<CellAvailabilityAttrs> {
    view(vnode: m.Vnode<CellAvailabilityAttrs>) {
        const row = vnode.attrs.row
        return (
            <div className='c-cell-availability td-group'>
                {(() => {
                    if (row.offer_item_type === 'tbo') {
                        return [
                            <span className='header'>
                                {row.is_active && <Icon name='checked' size='xs' type='success' tip='This TBO is active' />}
                                {(() => {
                                    return row.delivery_period ? `TBO - ${row.delivery_period} weeks` : 'TBO'
                                })()}
                            </span>,
                            row.supplier_name ? <span className='details'>{row.supplier_name}</span> : null,
                            <span className='details'>
                                Min/max: {row.minimum_quantity || '-'}/{row.maximum_quantity}
                            </span>,
                        ]
                    }

                    const {maximum_quantity, minimum_quantity} = row
                    return (
                        <div className='stock-info'>
                            <div className='stat'>
                                {maximum_quantity && maximum_quantity < row.number_of_cases_in_stock ? (
                                    <div className='stat'>
                                        <Icon
                                            name='stock'
                                            size='xs'
                                            tip={() => {
                                                return `Maximum Order Quantity: ${maximum_quantity}, Stock: ${row.number_of_cases_in_stock}`
                                            }}
                                            type='warning'
                                        />
                                        {`${maximum_quantity}(${row.number_of_cases_in_stock})`}
                                    </div>
                                ) : (
                                    <div className='stat'>
                                        <Icon
                                            name='stock'
                                            size='xs'
                                            tip={() =>
                                                `Available: ${row.number_of_cases_available ? row.number_of_cases_available : row.number_of_cases_in_stock}`
                                            }
                                        />
                                        {row.number_of_cases_in_stock}
                                    </div>
                                )}
                            </div>

                            {minimum_quantity && (
                                <div className='stat'>
                                    <Icon
                                        name='quantity_constraint'
                                        size='xs'
                                        tip={() => `Minimum Order Quantity: ${minimum_quantity}`}
                                        type='warning'
                                    />
                                    {minimum_quantity}
                                </div>
                            )}
                            <div className='stat'>
                                <Icon
                                    name='purchase'
                                    size='xs'
                                    tip={() => `Already In Purchase: ${row.number_of_cases_in_purchase}`}
                                />
                                {row.number_of_cases_in_purchase}
                            </div>
                            <div className='stat'>
                                <Icon
                                    name='sales'
                                    size='xs'
                                    tip={() => `Already in Sales Orders: ${row.number_of_cases_in_sales}`}
                                />
                                {row.number_of_cases_in_sales}
                            </div>
                            <div className='stat'>
                                <Icon name='shieldHalfFull' size='xs' tip={() => `Available: ${row.number_of_cases_available}`} />
                                {row.number_of_cases_available}
                            </div>
                        </div>
                    )
                })()}
            </div>
        )
    }
}
